export default "__VITE_ASSET__3gakiPd6__"